import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import { useContext, useState } from 'react'
import { ButtonDrawer, InputField } from '~/components'
import { StoreContext } from '~/store'
import { addVoucher } from '~/lib/api'
import { sleep } from '~/utils'
import { useTranslation } from 'react-i18next'
import * as styles from './index.module.css'

export default function AddVoucher({ onComplete }) {
  const { t } = useTranslation()
  const { user, refreshUser } = useContext(StoreContext)
  const [message, setMessage] = useState()

  const initialValues = {
    voucherCode: '',
  }

  return (
    <Formik 
      initialValues={initialValues}
      validationSchema={Yup.object({
        voucherCode: Yup.string().required(t('validation-need-voucher-code')),
      })}
      onSubmit={async (values) => {
        setMessage('')
        await sleep(500)
        addVoucher(user.userId, values.voucherCode).then((response) => {
          console.log(response)
          refreshUser()
          if (onComplete) onComplete()
        })
        .catch((error) => {
          console.error(error)
          setMessage(error?.response?.message)
        })
      }}
    >
      {({ errors, submitForm, isSubmitting }) => (
        <>
          <div className="flex flex-col w-full p-4 gap-1.5">
            <p className="text-[17px] font-semibold uppercase text-[#17181a] mb-2.5">{t('header-add-voucher')}</p>
            <Field name="voucherCode" placeholder={t('placeholder-voucher-code')} component={InputField} uppercase />
            {message && <div className={styles.message}>{message}</div>}
          </div>
          <ButtonDrawer modal buttons={[{ func: submitForm, title: t('button-save'), isLoading: isSubmitting }]} isLoading={isSubmitting} />
        </>
      )}
    </Formik>
  )
}

